import { PromiseCompletionSource } from "async/PromiseCompletionSource";
import { ICanvasScaler } from "by/gamefactory/canvas/ICanvasScaler";
import { GameFont } from "by/gamefactory/cityversetycoon/scenes/common/GameFont";
import { BasePageView } from "by/gamefactory/cityversetycoon/scenes/common/components/BasePageView";
import { ButtonWithScaleAnimation } from "by/gamefactory/cityversetycoon/scenes/common/components/ButtonWithScaleAnimation";
import { CommonResourcesPackage } from "by/gamefactory/cityversetycoon/scenes/common/resources/CommonResourcesPackage";
import { IDestroyOptions, Sprite, Text, TextStyle } from "pixi.js";
import { UnboardingType } from "../../../components/unboarding/UnboardingType";
import { ThirdPageHeaderTextContainer } from "../../../components/unboarding/textcontainers/ThirdPageHeaderTextContainer";
import { UnboardingResourcePackage } from "../../../resources/UnboardingResourcePackage";

export class ThirdPage extends BasePageView {
    private static readonly BUTTON_TEXT = "GOT IT!";

    private readonly operationControls: PromiseCompletionSource<void>;
    private readonly commonResources: CommonResourcesPackage;
    private readonly unboardingResources: UnboardingResourcePackage;
    private readonly type: UnboardingType;

    private background: Sprite;
    private textContainer: ThirdPageHeaderTextContainer;
    private cards: Sprite;
    private tokens: Sprite;
    private tokensAdditional: Sprite;
    private button: ButtonWithScaleAnimation;

    public constructor(
        operationControls: PromiseCompletionSource<void>,
        commonResources: CommonResourcesPackage,
        unboardingResources: UnboardingResourcePackage,
        canvasScaler: ICanvasScaler,
        type: UnboardingType
    ) {
        super(canvasScaler);
        this.operationControls = operationControls;
        this.commonResources = commonResources;
        this.unboardingResources = unboardingResources;
        this.type = type;
        this.build();
    }

    protected override build(): void {
        this.background = new Sprite(this.unboardingResources.assets_views_unboarding_stars_bg_third_page_png);
        this.addChild(this.background);
        this.textContainer = new ThirdPageHeaderTextContainer(this.type);
        this.addChild(this.textContainer);
        if (this.type === UnboardingType.OWNER) {
            this.tokensAdditional = new Sprite(this.unboardingResources.assets_views_unboarding_tokens_additional_png);
            this.addChild(this.tokensAdditional);
        }
        this.cards = new Sprite(this.unboardingResources.assets_views_unboarding_buildings_png);
        this.addChild(this.cards);
        if (this.type === UnboardingType.OWNER) {
            this.tokens = new Sprite(this.unboardingResources.assets_views_unboarding_tokens_bg_png);
            this.addChild(this.tokens);
        }
        this.button = new ButtonWithScaleAnimation(this.commonResources.assets_common_ui_button_green_png);
        this.button.width = 297;
        this.button.height = 156;
        this.button.onUp.add(this.buttonClickHandle, this);
        this.addChild(this.button);
        const buttonText = new Text(ThirdPage.BUTTON_TEXT, new ButtonTextStyle());
        buttonText.position.set(83, 39);
        this.button.defaultView.addChild(buttonText);
        super.build();
    }

    private buttonClickHandle() {
        this.button.interactive = false;
        this.operationControls.complete();
    }

    protected override layout(width: number, _height: number): void {
        switch (this.type) {
            case UnboardingType.OWNER:
                this.textContainer.position.set(334, 467);
                this.tokens?.position.set(0, 588);
                this.tokensAdditional?.position.set(52, 714)
                break;
            case UnboardingType.RENTER:
                this.textContainer.position.set(177, 453);
                break;
        }
        this.cards.position.set(0, 672);
        this.button.position.set(264, 1550);
    }

    public override destroy(options?: boolean | IDestroyOptions): void {
        this.button.onUp.remove(this.buttonClickHandle, this);
        super.destroy(options);
    }
}

class ButtonTextStyle extends TextStyle {
    public constructor() {
        super({
            fill: "#ffffff",
            fontFamily: GameFont.DEFAULT_FONT,
            dropShadow: true,
            dropShadowAlpha: 0.5,
            dropShadowAngle: 0.5,
            dropShadowBlur: 5,
            dropShadowDistance: 4,
            fontSize: 85,
            leading: 15,
            letterSpacing: 5.25
        });
    }
}